module.exports = __webpack_public_path__ + "static/media/2 7 Ordkjedetest-Starter-testen.d73284e1.mp3";